import React, { useState } from "react";
import styled from "styled-components";
import Swal from "sweetalert2";
import { CreateVendor, SignUpApi } from "../../common/CommonApi";

// ✅ Styled Components
const Container = styled.div`
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  background: #31d5c830;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 10px;
  color: #333;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Label = styled.label`
  font-weight: 500;
  color: #333;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    border-color: #30D5C8;
    outline: none;
  }
`;
const TextArea = styled.textarea`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    border-color: #30D5C8;
    outline: none;
  }
`;

const Select = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
`;

const Button = styled.button`
  background: #30D5C8;
  color: white;
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #0056b3;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const VendorForm = () => {
  const [form, setForm] = useState({
    email: "",
    // password:'',
    fullName: "",
    phone: "",
    companyName: "",
    address: "",
    category: "",
    isVendor: true,
    isActive: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate
    if (!form.fullName || !form.email || !form.phone) {
      Swal.fire("Please fill in all required fields");
      return;
    }
    try {
      const data = await CreateVendor(form);
      setForm({
        fullName: "",
        email: "",
        phone: "",
        companyName: "",
        address: "",
        category: "",
        isActive: false,
        isVendor: true,
        message: ""
      });
      if (data.data.message == "DATA_ALREADY_EXIST") {
        Swal.fire({
          title: "Success!",
          text: "You Email is already exist please login!",
          icon: "error",
        });
        return
      }
      Swal.fire({
        title: "Success!",
        text: "Vendor added successfully! You will get notify through call and mail",
        icon: "success",
      });

      // Reset form
    } catch (error) {
      console.log("error", error)
    }
  };
// console.log("-->partner-form")
  return (
    <Container>
      <Title>Partner Registration Form</Title>
      <Form onSubmit={handleSubmit}>
        <Label>Contact Person Name *</Label>
        <Input
          name="fullName"
          value={form.fullName}
          onChange={handleChange}
          placeholder="Enter vendor name"
        />

        <Label>Email *</Label>
        <Input
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Enter email address"
        />
        {/* <Label>Password *</Label>
        <Input
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Enter Password"
        /> */}

        <Label>Phone *</Label>
        <Input
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="Enter phone number"
        />

        <Label>Brand Name</Label>
        <Input
          name="companyName"
          value={form.companyName}
          onChange={handleChange}
          placeholder="Enter company name"
        />

        <Label>Address</Label>
        <Input
          name="address"
          value={form.address}
          onChange={handleChange}
          placeholder="Enter address"
        />

        <Label>Category</Label>
        <Select name="category" value={form.category} onChange={handleChange}>
          <option value="">Select category</option>
          <option value="electronics">Electronics</option>
          <option value="fashion">Fashion</option>
          <option value="furniture">Furniture</option>
          <option value="grocery">Grocery</option>
        </Select>

        <Label>Message</Label>
        <TextArea
          name="message"
          value={form.message}
          onChange={handleChange}
          placeholder="Enter Message"
        />

        <Button type="submit">Submit Partner</Button>
      </Form>
    </Container>
  );
};

export default VendorForm;
